import axios from 'axios';
import { isEmbeddedMode } from '../utils/embeddedMode';
import env from '../config/env';

const baseURL = env.apiUrl;

export const api = axios.create({
  baseURL,
  withCredentials: true,
});

// Add a request interceptor to include the auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access
      localStorage.removeItem('access_token');

      // Don't redirect in embedded mode (iOS WebView) - let the native app handle authentication
      if (isEmbeddedMode()) {
        console.log(
          '[API] Embedded mode detected - not redirecting to login, letting native app handle authentication'
        );
        return Promise.reject(error);
      }

      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);
